module.exports = __webpack_public_path__ + "media/images/bg-roulette-54570455bc403250bd741c155188e10f.png";